module.exports = __webpack_public_path__ + "static/media/dianbanre_banner1.8feb96bb.png";